const params = new URLSearchParams(window.location.search);

declare global {
    var DESARROLLO: boolean;
    var TEST: boolean;
}

export default Object.seal({
    gdprApplies: true,
    apiVersion: "2.0",
    customStringVersion: 1,
    vendorListJSONUrl: `https://${global.DESARROLLO ? 'local-' : (global.TEST ? 'test-' : '')}services.meteored.com/web/cmp/v4/$$lang$$/gvl.json`,
    logging: params.get('cmp-debug') === 'true',
    serviceSpecific: true,
});
